import _ from 'lodash'

import { FETCHING_NODES, FETCHED_NODES } from '_reducers/nodes'

import { MydAPI } from '_services/default'
import { CancelToken } from 'axios'
import { deserializeGeneric } from 'utils/relationships'


const bucketBaseUrl = 'http://www.criss.tech/assets/uploads/files/s3-criss'

export function _processImage(node) {
  if ( node.img !== null){
    return `${bucketBaseUrl}/${node.img}`

  } else if ( node.img === null && node.typeId === 1){
    return `${bucketBaseUrl}/icon-scenario135.png`

  } else if ( node.img === null && node.typeId === 2){
    return `${bucketBaseUrl}/icon-activity135.png`

  } else if ( node.img === null && node.typeId === 3){
    return `${bucketBaseUrl}/icon-task135.png`
  }
}

export const _proccessAttachement = (attachement) => {
  if( ! _.isEmpty(attachement)) {
    return `${bucketBaseUrl}/${attachement}`
  } else {
    return false
  }
}


export function _processType(node) {
  switch(node.typeId) {
    case 1:
      return 'Scenario'
    case 2:
      return 'Activity'
    case 3:
      return 'Task'
    default:
      return null
  }
}

function _fetchingNodes() {
  return { type: FETCHING_NODES }
}

function _fetchedNodes(nodes) {
  return { type: FETCHED_NODES, nodes }
}

/*function _fetchedNode(node) {
  return { type: FETCHED_NODE, node }
}*/

export const deserializeNodeData = (data) => {
  return _.map(data.data, node => {
    const { id, attributes, relationships } = node

    let casNodeObject = _.chain(data.included).find({
      id: _.parseInt(relationships.nodeObject.data.id),
      type: 'cas_node_object',
    }).value()

    casNodeObject = {
      ...casNodeObject,
      attributes: {
        ...casNodeObject.attributes,
        img: _processImage(casNodeObject.attributes),
        type: _processType(casNodeObject.attributes),
      }
    }

    return {
      id,
      ...attributes,
      relationships: node.relationships,
      content: {
         id: casNodeObject.id,
         ..._.get(casNodeObject, 'attributes', {}),
      },
      indicators: _.chain(casNodeObject.relationships).get('indicators.data', []).map(indicator => {
        let d = _.find(data.included, {
          id: _.parseInt(indicator.id),
          type: 'indicator',
        })

        return {
          indicatorId: _.parseInt(d.id),
          ...d.attributes,
        }
      }).value(),
      evaluation: _.chain(casNodeObject.relationships).get('defaultEvaluations.data', []).map(evaluation => {
        let d = _.find(data.included, {
          id: _.parseInt(evaluation.id),
          type: 'ict_evaluation_default',
        })

        return {
          evaluationId: _.parseInt(d.id),
          ...d.attributes,
          methodologies: _.map(d.relationships.methodologies.data, i=> {return _.parseInt(i.id)})
        }
      }).value()
    }
  })
}

let fetchNodesCancelToken = null

export const fetchNodes = _.memoize((page=1) => {
  return dispatch => new Promise((resolve, reject) => {
    dispatch(_fetchingNodes())

    if (fetchNodesCancelToken)
      fetchNodesCancelToken()

    MydAPI.get('/cas/nodes?include=node_object,node_object.indicators',
      {
        cancelToken: new CancelToken(function executor(c) {
          fetchNodesCancelToken = c
        }),
      }
    ).then(nodes => {
      let retNodes = deserializeNodeData(nodes.data)

      dispatch(_fetchedNodes(retNodes))
      resolve(retNodes)

    }).catch(err => {
      if (err.__CANCEL__ !== true) {
        reject(err)
      }
    })
  })
})

let fetchNodesByPlanningIdCancelToken = null

export const fetchNodesByPlanningId = (planningId) => {
  return dispatch => new Promise((resolve, reject) => {
    dispatch(_fetchingNodes())

    if (fetchNodesByPlanningIdCancelToken)
      fetchNodesByPlanningIdCancelToken()

    MydAPI.get(
      `/ict/plannings/${planningId}/relationships/casnodes?include=casnodes.node_object.indicators`,
      {
        cancelToken: new CancelToken(function executor(c) {
          fetchNodesByPlanningIdCancelToken = c
        }),
      }
    ).then(nodes => {

      const reorderNodes = _.map(
        nodes.data.data,
        item => _.find(nodes.data.included, {id: item.id, type: item.type})
      )

      const newData = {
        data: reorderNodes,
        included: nodes.data.included,
      }

      let retNodes = deserializeNodeData(newData)

      dispatch(_fetchedNodes(retNodes))
      resolve(retNodes)

    }).catch(err => {
      if (err.__CANCEL__ !== true) {
        reject(err)
      }
    })
  })
}

export const fetchNode = nodeId => {
  return new Promise((resolve, reject) => {
    MydAPI.get(`/cas/nodes/${nodeId}?include=node_object.indicators`).then(nodes => {
      let _nodes = {
            ...nodes.data,
            data: [
              nodes.data.data,
            ]
          },
          retNode = deserializeNodeData(_nodes)

      retNode = _.head(retNode)

      resolve(retNode)

    }).catch(err => {
      reject(err)
    })
  })
}

export const saveNode = (_data, nodeId=false) => {
  return new Promise((resolve, reject) => {
    let url = `/cas/nodes`
    let _method = MydAPI.post
    let data = {
      type: 'cas_node',
      attributes: {
        title: _data.title,
        description: _.get(_data, 'description', ''),
        organization_id: _.get(_data, 'organizationId', false),
      },
      relationships: {
        subjects: {
          data: _.map(
            _.get(_data, 'subjects', []),
            item => ({
              type: 'subject',
              id: item,
            })
          ),
        },
        competences: {
          data: _.map(
            _.get(_data, 'competences', []),
            item => ({
              type: 'competence',
              id: item,
            })
          ),
        },
        tags: {
          data: _.map(
            _.get(_data, 'tags', []),
            item => ({
              type: 'tag',
              id: item,
            })
          ),
        },
        education_levels: {
          data: _.map(
            _.get(_data, 'educationLevels', []),
            item => ({
              type: 'education_level',
              id: item,
            })
          ),
        },
        languages: {
          data: _.map(
            _data.languages,
            item => ({
              type: 'language',
              id: item,
            })
          ),
        }
      }
    }

    if (nodeId) {
      data.id = nodeId
      _method = MydAPI.patch
      url = `/cas/node/${nodeId}`
    }

    _method(`${url}?include=subjects,languages,competences,education_levels,tags`, {data}).then(res => {
      resolve(deserializeGeneric(res.data.data))
    }).catch(err => {
      reject(err)
    })
  })
}

export const createOrUpdateNode = () => {}

let searchNodesCancelToken = null

export const searchNodes = _.memoize(
  (filters=[], page=1) => {
    return new Promise((resolve, reject) => {

      let _filters = _.reduce(filters, (ret, value, name) => {

        if ( ! value)
            return ret

        switch(name) {
          case 'search':
            return {
              ...ret,
              search: value,
            }
          case 'date':
            return {
              ...ret,
              date: value,
            }
          case 'privacy':
            return {
              ...ret,
              privacy: value,
            }
          case 'language_id':
            return {
              ...ret,
              language_id: value,
            }
          case 'education_level':
            return {
              ...ret,
              education_level: value,
            }
          default:
            return ret
        }
      }, {
        include: 'node_object',
      })

      let url = _filters.privacy ? _.chain(_filters.privacy).replace('criss', '').toLower().value() : ''

      _filters = {
        ..._filters,
        'page[number]': page,
      }

      if (searchNodesCancelToken)
        searchNodesCancelToken()

      MydAPI.get(
        `/cas/nodes/${url}`,
        {
          'params': _filters,
          cancelToken:  new CancelToken(function executor(c) {
            searchNodesCancelToken = c
          }),
        }
      ).then(nodes => {
        resolve({
          data: deserializeNodeData(nodes.data),
          maxPage: _.ceil(nodes.data.meta.count / 10),
        })
      }).catch(err => {
        if (err.__CANCEL__ !== true) {
          reject(err)
        }
      })
    })
  },
  (a, b) => {
    return JSON.stringify(
      {
        ...a,
        page: b,
      }
    )
  }
)

export const fetchNodesDescendants = _.memoize(
  nodeId => new Promise((resolve, reject) => {
    MydAPI.get(`/cas/nodes/${nodeId}/descendants?page[size]=0&include=node_object.indicators,node_object.default_evaluations,node_object.default_evaluations.methodologies`,).then(
      nodes => {
        resolve(deserializeNodeData(nodes.data))
      }
    ).catch(err => {
      reject(err)
    })
  })
)

export const fetchNodesAscendants = _.memoize(nodeId => {
  return new Promise((resolve, reject) => {

    MydAPI.get(`/cas/nodes/${nodeId}/ascendants?page[size]=0&include=node_object,node_object.indicators,node_object.default_evaluations,node_object.default_evaluations.methodologies`).then(nodes => {
      let retNodes = deserializeNodeData(nodes.data)
      resolve(retNodes)
    }).catch(err => {
      reject(err)
    })
  })
})

export const _proccessMeasureData = (data) => {
  if (!_.isEmpty(data)) {
    let areas = _.map(data.areas, area => {
      return { 'label': area.title, 'percent': area.achievedPercentage.toFixed(2) }
    })

    let subCompetences = _.map(data.subcompetences, subCompetence => {
      return { 'label': subCompetence.title, 'percent': subCompetence.achievedPercentage.toFixed(2) }
    })

    return [
      {
        'label': 'Areas',
        'data': areas,
        'total': data.total.toFixed(2),
      },
      {
        'label':'Subcompetences',
        'data': subCompetences,
      },
    ]
  }
  return null
}

export const nodeMeasure = _.memoize(nodeId => {
  return new Promise((resolve, reject) => {
    MydAPI.get(`/cas/nodes/${nodeId}/measure`).then(nodes => {
      let retNodes = _proccessMeasureData(nodes.data.data)

      resolve(retNodes)

    }).catch(err => {
      reject(err)
    })
  })
})

export const measureNodesList = _.memoize(nodeIds => {
  return new Promise((resolve, reject) => {
    MydAPI.post('/cas/nodes/measure', nodeIds).then(nodes => {
      let retNodes = _proccessMeasureData(nodes.data.data)

      resolve(retNodes)

    }).catch(err => {
      reject(err)
    })
  })
})

export const digitalCompetencesAchievedByNodeFromEvaluation = _.memoize((evaluationId, nodeId, ratios=[]) => {
  return new Promise((resolve, reject) => {
    MydAPI.get(`/evaluations/${evaluationId}/nodes/${nodeId}/achieved`, ratios).then(nodes => {
      let retNodes = _proccessMeasureData(nodes.data.data)

      resolve(retNodes)

    }).catch(err => {
      reject(err)
    })
  })
})

export const fetchNodeMetadata = (nodeObjectId) =>  {
  return new Promise((resolve, reject) => {
    MydAPI.get(`/cas/nodes/objects/${nodeObjectId}/metadata`,
        {
          cancelToken:  new CancelToken(function executor(c) {
            searchNodesCancelToken = c
          }),
        }
      ).then(content => {

      let data = content.data.data,
          extraData

      switch(content.data.data.type) {
        case('scenario'):
          extraData = {
            instructionalApproach: data.attributes.instructionalApproach,
            languages: data.attributes.languages,
          }
          break
        case('activity'):
          extraData = {
            theme: data.attributes.theme,
          }
          break
        case('task'):
          extraData = {
            length: data.attributes.length,
            type: data.attributes.type,
            att1: {
              link: _proccessAttachement(data.attributes.att1),
              name: data.attributes.att1,
            },
            att2: {
              link: _proccessAttachement(data.attributes.att2),
              name: data.attributes.att2,
            },
            att3: {
              link: _proccessAttachement(data.attributes.att3),
              name: data.attributes.att3,
            },
          }
          break
        default:
          break
      }
      resolve(extraData)
    }).catch(err => {
      reject(err)
    })
  })
}

export function fetchCrissLanguages() {
  return new Promise((resolve, reject) => {

    MydAPI.get('/criss_languages?page[size]=0').then(languages => {
      let retLanguages = _.map(languages.data.data, languages => {
        return {
          id: languages.id,
          ...languages.attributes,
        }
      })
      resolve(retLanguages)

    }).catch(err => {
      reject(err)
    })
  })
}
